import { SnackbarOrigin } from "@mui/material";

import {
  authButton,
  authLink,
  authSmallText,
  colors,
  inputHint,
} from "../../theme";

const styles = {
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'right',
  } as SnackbarOrigin,
  alert: {
    width: '100%',
  },
  // Same place as the toast of the login: under the nav bar of the public pages.
  toast: {
    top: '80px !important',
  },
  subtitle: {
    ...authSmallText,
    mt: 1,
    fontSize: 13.5,
  },
  linkTypo: authLink,
  smallText: authSmallText,
  smallLink: {
    ...authSmallText,
    fontWeight: 700,
    color: colors.text,
  },
  hint: {
    ...inputHint,
    color: colors.textSecondary,
  },
  validateButton: authButton,
};

export default styles;
